// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card__body[data-v-4cde402a]{padding:2.1875rem}.btns[data-v-4cde402a]{display:flex;justify-content:center}.btns>button[data-v-4cde402a]{margin:0 1.875rem}", ""]);
// Exports
module.exports = exports;
